(function () {
  if (!window.MutationObserver || !document.documentElement) return;
  var PH = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
  var groups = { ugc: { held: [], done: false }, galerie: { held: [], done: false } };
  var firstWatched = false;
  var groupOf = function (img) {
    if (!img.closest) return null;
    if (img.closest('.nh-ugc21')) return 'ugc';
    var track = img.closest('[data-gallery-scroll]');
    if (!track) return null;
    var slide = img.closest('[data-slide-index]');
    if (!slide || slide.getAttribute('data-slide-index') === '0') return null;
    return 'galerie';
  };
  var watchFirst = function (img) {
    if (firstWatched || !img.closest || !img.closest('[data-gallery-scroll]')) return;
    var slide = img.closest('[data-slide-index]');
    if (!slide || slide.getAttribute('data-slide-index') !== '0') return;
    firstWatched = true;
    var go = function () { setTimeout(function () { release('galerie'); }, 0); };
    if (img.complete && img.naturalWidth > 0) go();
    else { img.addEventListener('load', go, { once: true }); img.addEventListener('error', go, { once: true }); }
  };
  var hold = function (img) {
    watchFirst(img);
    var g = groupOf(img);
    if (!g) return;
    if (img.hasAttribute('data-fw-hold')) { groups[g].held.push(img); return; }
    if (groups[g].done || img.getAttribute('loading') !== 'lazy') return;
    var src = img.getAttribute('src');
    if (!src || src.indexOf('data:') === 0) return;
    img.setAttribute('data-fw-hold', src);
    var srcset = img.getAttribute('srcset');
    if (srcset) { img.setAttribute('data-fw-hold-srcset', srcset); img.removeAttribute('srcset'); }
    img.setAttribute('src', PH);
    groups[g].held.push(img);
  };
  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var nodes = records[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'IMG') hold(node);
        else { var list = node.getElementsByTagName('img'); for (var k = 0; k < list.length; k++) hold(list[k]); }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  var release = function (name) {
    var grp = groups[name];
    if (!grp || grp.done) return;
    grp.done = true;
    grp.held.forEach(function (img) {
      var src = img.getAttribute('data-fw-hold');
      var srcset = img.getAttribute('data-fw-hold-srcset');
      if (srcset && !img.hasAttribute('srcset')) img.setAttribute('srcset', srcset);
      if (src && img.getAttribute('src') === PH) img.setAttribute('src', src);
      img.removeAttribute('data-fw-hold');
      img.removeAttribute('data-fw-hold-srcset');
    });
    grp.held = [];
    if (groups.ugc.done && groups.galerie.done) mo.disconnect();
  };
  var near = null;
  var ugcNear = function () {
    release('galerie');
    if (groups.ugc.done || near) return;
    if (!('IntersectionObserver' in window)) { release('ugc'); return; }
    near = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        near.unobserve(entry.target);
        groups.ugc.held = groups.ugc.held.filter(function (img) {
          if (!entry.target.contains(img)) return true;
          var src = img.getAttribute('data-fw-hold'); var srcset = img.getAttribute('data-fw-hold-srcset');
          if (srcset && !img.hasAttribute('srcset')) img.setAttribute('srcset', srcset);
          if (src && img.getAttribute('src') === PH) img.setAttribute('src', src);
          img.removeAttribute('data-fw-hold'); img.removeAttribute('data-fw-hold-srcset');
          return false;
        });
      });
    }, { rootMargin: '1250px 0px' });
    [].forEach.call(document.querySelectorAll('.nh-ugc21'), function (section) { near.observe(section); });
  };
  var all = function () { ugcNear(); detach(); };
  var inputs = ['touchstart', 'pointerdown', 'keydown', 'wheel'];
  var detach = function () {
    window.removeEventListener('scroll', all);
    inputs.forEach(function (type) { window.removeEventListener(type, all, true); });
  };
  window.addEventListener('scroll', all, { passive: true });
  inputs.forEach(function (type) { window.addEventListener(type, all, { capture: true, passive: true }); });
  window.addEventListener('load', all);
  window.setTimeout(all, 9000);
})();
